import * as React from 'react';
import { SvgIcon, color } from '@kis-technologies/kis-ui';
import { ArrowPaginationButton, useStyles } from '../styled';
import { PaginationProps } from '../types';

export const ArrowPagination = (props: PaginationProps) => {
  const { page, pages, onPageChange } = props;
  const classes = useStyles();
  if (pages <= 1) return null;

  return (
    <>
      {page !== 1 && (
        <ArrowPaginationButton
          position="left"
          onClick={() => onPageChange(page - 1)}
          data-testid="arrow-pagination-prev"
          className={classes.arrowPaginationPrev}
        >
          <SvgIcon name="prev_circle" color={color.DARK_GRAY} size={76} />
        </ArrowPaginationButton>
      )}
      {page !== pages && (
        <ArrowPaginationButton
          position="right"
          onClick={() => onPageChange(page + 1)}
          data-testid="arrow-pagination-next"
          className={classes.arrowPaginationNext}
        >
          <SvgIcon name="next_circle" color={color.DARK_GRAY} size={76} />
        </ArrowPaginationButton>
      )}
    </>
  );
};
